<button
  #trigger
  type="button"
  data-testid="kpi-picker-trigger"
  class="text-accent-main hover:text-accent-hover hover:bg-interactive inline-flex cursor-pointer items-center gap-1 rounded-sm px-1 py-0.5 text-[11px] font-medium whitespace-nowrap transition-colors"
  aria-haspopup="true"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-label]="'features.plan.panel.kpis.choose_label' | translate"
  (click)="toggleOpen()">
  <i [class]="ICONS.slidersHorizontal" aria-hidden="true"></i>
  {{ 'features.plan.panel.kpis.choose' | translate }}
</button>

<app-dropdown
  [target]="trigger"
  [template]="menu"
  [isOpen]="isOpen()"
  [onClose]="onClose"
  position="bottom-end"
  [width]="236"
  [closeOnClickOutside]="true"
  [closeOnEscape]="true" />

<ng-template #menu>
  <div class="flex flex-col">
    <label
      class="border-default text-text-tertiary focus-within:border-accent-focus m-0.5 mb-1 flex h-7 items-center gap-1.5 rounded-sm border px-2">
      <i [class]="ICONS.magnifyingGlass" aria-hidden="true"></i>
      <input
        data-testid="kpi-picker-search"
        type="search"
        #search
        class="text-text-primary placeholder:text-text-tertiary min-w-0 flex-1 bg-transparent text-xs outline-none [&::-webkit-search-cancel-button]:appearance-none"
        [value]="query()"
        [placeholder]="'features.plan.panel.kpis.search' | translate"
        [attr.aria-label]="'features.plan.panel.kpis.search' | translate"
        (input)="onSearch($event)" />
      @if (query()) {
        <button
          type="button"
          data-testid="kpi-picker-search-clear"
          class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer text-sm"
          [attr.aria-label]="'common.clear' | translate"
          [title]="'common.clear' | translate"
          (click)="clearSearch(search)">
          <i [class]="ICONS.x" aria-hidden="true"></i>
        </button>
      }
    </label>
    <div class="flex max-h-64 flex-col overflow-y-auto">
      @for (option of options(); track option.id) {
        <app-checkbox
          data-testid="kpi-picker-option"
          class="hover:bg-interactive rounded-sm px-1.5 py-1 transition-colors"
          [label]="option.label"
          [checked]="option.shown"
          [onChange]="option.toggle" />
      } @empty {
        <p class="text-text-tertiary px-1.5 py-1 text-xs">
          {{ 'features.plan.panel.kpis.no_match' | translate }}
        </p>
      }
    </div>
    <p
      class="border-weak text-text-tertiary mt-1 border-t px-1.5 pt-1.5 pb-0.5 text-[11px]">
      {{ 'features.plan.panel.kpis.own_list_note' | translate }}
    </p>
  </div>
</ng-template>
